export default __webpack_public_path__ + "static/aplicativo-1e2e2941deeab81ce8532f5121a4043f.png";